/** @jsxImportSource @emotion/react */
/** @jsxFrag */

import { ChangeEvent, memo } from "react";

import { Typography } from "@material-ui/core";

import { Label, Checkbox } from "..";

import { checkbox, error } from "./styles";

interface CheckboxType {
  label: string;
  value: string;
  disabled?: boolean;
}

interface Props {
  label: string;
  tip?: string;
  value: string[];
  checkboxes: CheckboxType[];
  onChange: (value: string[]) => void;
  disabled?: boolean;
  helperText?: string;
}

const CheckboxGroup = ({ label, tip, value, checkboxes, onChange, disabled, helperText }: Props): JSX.Element => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const checkValues: any = new Set(value);

    if (e.target.checked) {
      checkValues.add(e.target.value);
    } else {
      checkValues.delete(e.target.value);
    }

    onChange([...checkValues]);
  };

  const renderCheckboxes = (): JSX.Element[] =>
    checkboxes.map(({ value: val, disabled: disabledEach, ...rest }, i) => (
      <Checkbox
        // eslint-disable-next-line react/no-array-index-key
        key={`checkbox-${i}`}
        css={i && checkbox}
        value={val}
        checked={value.includes(val)}
        onChange={handleChange}
        disabled={disabled || disabledEach}
        {...rest}
      />
    ));

  return (
    <>
      <Label text={label} tip={tip} />
      {renderCheckboxes()}
      {helperText && (
        <Typography css={error} variant="caption" color="error">
          {helperText}
        </Typography>
      )}
    </>
  );
};

export default memo(CheckboxGroup);
